'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OnUpdate = function (_React$Component) {
  (0, _inherits3.default)(OnUpdate, _React$Component);

  function OnUpdate() {
    (0, _classCallCheck3.default)(this, OnUpdate);
    return (0, _possibleConstructorReturn3.default)(this, (OnUpdate.__proto__ || (0, _getPrototypeOf2.default)(OnUpdate)).apply(this, arguments));
  }

  (0, _createClass3.default)(OnUpdate, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.cb();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return OnUpdate;
}(_react2.default.Component);

OnUpdate.propTypes = {
  cb: _propTypes2.default.func.isRequired
};
exports.default = OnUpdate;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9PblVwZGF0ZS5qcyJdLCJuYW1lcyI6WyJPblVwZGF0ZSIsInByb3BzIiwiY2IiLCJDb21wb25lbnQiLCJwcm9wVHlwZXMiLCJmdW5jIiwiaXNSZXF1aXJlZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFQTs7OztBQUNBOzs7Ozs7SUFFcUJBLFE7Ozs7Ozs7Ozs7eUNBS0U7QUFDbkIsV0FBS0MsS0FBTCxDQUFXQyxFQUFYO0FBQ0Q7Ozs2QkFFYTtBQUNaLGFBQU8sSUFBUDtBQUNEOzs7RUFYbUMsZ0JBQU1DLFM7O0FBQXZCSCxRLENBQ1pJLFMsR0FBWTtBQUNqQkYsTUFBSSxvQkFBVUcsSUFBVixDQUFlQztBQURGLEM7a0JBREFOLFEiLCJmaWxlIjoiT25VcGRhdGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBAZmxvdyAqL1xuXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgT25VcGRhdGUgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIGNiOiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkXG4gIH07XG5cbiAgY29tcG9uZW50RGlkVXBkYXRlKCkge1xuICAgIHRoaXMucHJvcHMuY2IoKTtcbiAgfVxuXG4gIHJlbmRlcigpOiBhbnkge1xuICAgIHJldHVybiBudWxsO1xuICB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/react-draggable-list/js/OnUpdate.js
// module id = 1007
// module chunks = 0